import React from "react"

import classNames from "classnames"

import { IconSize } from "shared/types/Icon"

import { Icon } from "../icon/Icon"
import { IconName } from "../icon/__generated__/IconName"
import "./styles/_drag-ghost.scss"

export interface DragGhostProps {
  icon?: IconName
  text: string
  className?: string
  error?: boolean
  "data-testid"?: string
}

export const DragGhost = React.forwardRef<HTMLDivElement, DragGhostProps>(
  ({ icon, text, className, error, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        className={classNames(
          "drag-ghost",
          { "drag-ghost--error": error },
          className
        )}
        {...rest}
      >
        {icon && (
          <Icon
            name={icon}
            size={IconSize.SMALL}
            className="drag-ghost__icon"
          />
        )}
        <span className="drag-ghost__text">{text}</span>
      </div>
    )
  }
)

DragGhost.displayName = "DragGhost"
